export default __webpack_public_path__ + "static/media/editform.7e281355.svg";